<template>
  <v-container>
    <v-tabs
      class="v-tabs--pill primary white--text"
      hide-slider
      active-class="white primary--text"
      v-model="tab"
      show-arrows
      dark
      background-color="transparent"
      centered
      touchless
      icons-and-text
    >
      <v-tab
        touchless
        class="white--text font-weight-medium"
        v-for="item in items"
        :key="item"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
    <v-tabs-items touchless v-model="tab" class="transparent">
      <v-tab-item>
        <keep-alive><equipment-list></equipment-list></keep-alive>
      </v-tab-item>
      <v-tab-item>
        <keep-alive> <area-list></area-list></keep-alive>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
export default {
  name: "AssetsModule",
  components: {
    equipmentList: () => import("../EquipmentList/Index"),
    areaList: () => import("../AreaList/Index")
  },
  data() {
    return {
      color: "primary",
      tab: this.$t("equipmentList.v-card-title"),
      items: [
        this.$t("equipmentList.v-card-title"),
        this.$t("equipmentList.plantList")
      ]
    };
  }
};
</script>

<style lang="sass" scoped>
.v-tab
  max-width: unset
  width: 50%
.v-tabs--pill
  .v-tab,
  .v-tab:before
    border-radius: 0 !important

  &.v-tabs--icons-and-text
    .v-tab,
    .v-tab:before
      border-radius: 4px
</style>
